import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from "./../Container";
import { Paper } from "./../Paper";
import { misc } from "../icons";
import styled from "@emotion/styled";
import { useElementsContext } from "../elementsProvider";
export function RTCFAQs({ iconColor, subelements, textColor, textTypography, titleColor, titleTypography, }) {
    const { isMobile } = useElementsContext();
    return (_jsx(Container, { children: _jsx(PaperStyled, Object.assign({ isDesktop: !isMobile }, { children: subelements.map((subelement) => {
                return (_jsxs(FAQContainer, Object.assign({ isDesktop: !isMobile }, { children: [_jsxs(FAQHeader, Object.assign({ iconColor: iconColor, titleColor: titleColor, typography: titleTypography, isDesktop: !isMobile }, { children: [misc[subelement.iconName],
                                _jsx(FAQTitle, Object.assign({ isDesktop: !isMobile }, { children: subelement.question }), void 0)] }), void 0),
                        _jsx(FAQBody, { textTypography: textTypography, textColor: textColor, dangerouslySetInnerHTML: { __html: subelement.answer } }, void 0)] }), subelement.identifier));
            }) }), void 0) }, void 0));
}
const PaperStyled = styled(Paper)(({ isDesktop }) => (Object.assign({ display: "flex", flexDirection: "column", padding: "0 3.6rem" }, (isDesktop
    ? {
        padding: "0 15.2rem",
    }
    : {}))));
const FAQContainer = styled.article(({ isDesktop }) => (Object.assign({ borderBottom: "solid 1px hsla(0, 0%, 59%, 1)", padding: "3.6rem 0", "&:last-of-type": {
        borderBottom: "none",
    } }, (isDesktop
    ? {
        padding: "4.8rem 0",
    }
    : {}))));
const FAQHeader = styled.div(({ iconColor, titleColor, typography, isDesktop }) => (Object.assign(Object.assign({ color: titleColor, fontFamily: typography, fontSize: "1.8rem", paddingBottom: "1.6rem", verticalAlign: "bottom" }, (isDesktop
    ? {
        fontSize: "2.4rem",
    }
    : {})), { "& svg": Object.assign({ color: iconColor, height: "2rem", paddingRight: "1.2rem", width: "auto" }, (isDesktop
        ? {
            height: "3.2rem",
        }
        : {})) })));
const FAQBody = styled.div(({ textColor, textTypography }) => ({
    color: textColor,
    fontFamily: textTypography,
    fontSize: "1.6rem",
}));
const FAQTitle = styled.h2(({ isDesktop }) => (Object.assign({ fontSize: "1.8rem", margin: 0, display: "inline-block", fontWeight: 500 }, (isDesktop
    ? {
        fontSize: "2.4rem",
    }
    : {}))));
//# sourceMappingURL=RTCFAQs.js.map